(function () {
  'use strict';

  var EXTRA_OFFSET = 8;

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function getHeaderOffset() {
    var raw = getComputedStyle(document.documentElement).getPropertyValue('--site-header-height');
    var parsed = parseFloat(raw);
    return (isNaN(parsed) ? 96 : parsed) + EXTRA_OFFSET;
  }

  function normalizePath(pathname) {
    if (!pathname || pathname === '/') return '/';
    return pathname.replace(/\/$/, '');
  }

  function getTarget(hash) {
    if (!hash || hash === '#') return null;
    try {
      return document.querySelector(hash);
    } catch (error) {
      return null;
    }
  }

  function scrollToTarget(target) {
    if (!target) return;

    var top = target.getBoundingClientRect().top + window.scrollY - getHeaderOffset();

    window.scrollTo({
      top: Math.max(0, top),
      behavior: prefersReducedMotion() ? 'auto' : 'smooth',
    });
  }

  function scrollToHash(hash, updateHistory) {
    var target = getTarget(hash);
    if (!target) return false;

    scrollToTarget(target);

    if (updateHistory !== false && window.location.hash !== hash) {
      history.pushState(null, '', hash);
    }

    return true;
  }

  function isSamePageLink(url) {
    var current = new URL(window.location.href);
    return (
      url.origin === current.origin &&
      normalizePath(url.pathname) === normalizePath(current.pathname)
    );
  }

  function onAnchorClick(event) {
    var link = event.target.closest('a[href*="#"]');
    if (!link || link.target === '_blank' || link.hasAttribute('download') || event.defaultPrevented) {
      return;
    }

    var url;
    try {
      url = new URL(link.href, window.location.href);
    } catch (error) {
      return;
    }

    if (!url.hash || !isSamePageLink(url)) return;

    var target = getTarget(url.hash);
    if (!target) return;

    event.preventDefault();
    scrollToHash(url.hash);
  }

  function onHashLoad() {
    if (!window.location.hash) return;

    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }

    window.scrollTo(0, 0);

    window.requestAnimationFrame(function () {
      scrollToHash(window.location.hash, false);
    });
  }

  document.addEventListener('click', onAnchorClick);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onHashLoad);
  } else {
    onHashLoad();
  }

  window.addEventListener('hashchange', function () {
    if (window.location.hash) {
      scrollToHash(window.location.hash, false);
    }
  });
})();
